import { render, staticRenderFns } from "./userlookup.vue?vue&type=template&id=524e12e6&"
import script from "./userlookup.vue?vue&type=script&lang=js&"
export * from "./userlookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports